import React from 'react';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Stack } from '@cp/ds/src/components/stack';
import { Button } from '@cp/ds/src/components/button';
import { MapPointIcon } from '@cp/ds/src/icons/mapPoint';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { CitySearchFormField } from '@cp/entities/location';
import { LocationIcon } from '@cp/ds/src/icons';
import { CatalogNavVacancyViewProps } from './model';

const ViewDesktop: React.FC<CatalogNavVacancyViewProps> = ({ onMapButtonClick, sx }) => {
  const theme = useTheme();
  const isTabletScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const containerSx = React.useMemo(
    () =>
      mergeSx(
        {
          width: 1,
          backgroundColor: 'white',
          borderRadius: '16px',
          px: 2,
          py: 1.5,
          alignItems: 'flex-end',
          boxShadow: '14px 17px 40px 4px rgba(138, 182, 209, 0.08)',
        },
        sx,
      ),
    [sx],
  );

  return (
    <Stack component="form" direction="row" gap={3} noValidate sx={containerSx}>
      <CitySearchFormField
        endAdornment={<LocationIcon fontSize="1rem" sx={{ color: 'rgba(244, 105, 116, 1)' /* NOTE: hardcoded color used in design */ }} />}
        fieldContainerProps={{ sx: { flex: '1 1 0px' } }}
        fieldLabel="Город"
        placeholder="Поиск города..."
        size="small"
      />

      {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
      <Button
        color="gray ultra light"
        onClick={onMapButtonClick}
        size="small"
        sx={{ minWidth: isTabletScreen ? undefined : 350 }}
        variant="secondary"
      >
        Смотреть на карте <MapPointIcon sx={{ marginTop: '-0.125rem', marginBottom: '-0.125rem' }} />
      </Button>
    </Stack>
  );
};

export default ViewDesktop;
